/* tslint:disable */
/* eslint-disable */
/**
 * Green0meter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Values: 0=Short, 1=Medium, 2=Long
 * @export
 * @enum {number}
 */

export enum DoubleMaterialityQuestionTimeHorizon {
    Short = 0,
    Medium = 1,
    Long = 2
}


